module.exports = __webpack_public_path__ + "img/MTABAPPSPIRO+.0114c51e.jpg";